import React from 'react';

import PropTypes from 'prop-types';

import { HintText } from 'components/HintText/HintText';
import { HINTTEXT_TYPE } from 'components/HintText/HintTextType';

export const UnsupportedFiles = ({ unsupportedFilesCount }) => {
  if (!unsupportedFilesCount) {
    return null;
  }

  return (
    <div className="form-upload__warning-message-unsupported">
      <HintText
        type={
          HINTTEXT_TYPE.ERROR
        }>{`Nicht unterstützte Dateitypen wurden gefiltert (${unsupportedFilesCount} Datein(en))`}</HintText>
    </div>
  );
};

UnsupportedFiles.propTypes = {
  unsupportedFilesCount: PropTypes.number.isRequired,
};
